import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {forkJoin} from 'rxjs';
import {MenuItem, SelectItem} from 'primeng/api';
import {Table} from 'primeng/table';
import {classToClass, plainToClass} from 'class-transformer';

import {GrowlService, UserService} from '@app/core';

import {
  ApprovalRequest,
  ApprovalStatusType,
  BreadcrumbMain,
  Browser,
  CommonDataService,
  CommonTransformationService,
  DocumentType,
  EnumType,
  FileExplorerDisplay,
  FileService,
  Format,
  GrowlType,
  JobRequisitionCandidateInfo,
  PrimeNgConfig,
  RouteLink,
  SafeHtmlPipe,
  TableColumn,
  TableFormat,
  ToDo,
  ToDoComment,
  TradingPartnerService,
  Transaction,
  UserInfo,
  Validation,
  WorklistType
} from '@app/shared';

import {Notification, SearchOption, TxnStructure, WorkItem, WorklistCount} from './worklist';
import {WorklistDataService} from './worklist-data.service';
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-worklist',
  templateUrl: './worklist.component.html',
  styleUrls: ['./worklist.component.css'],
  providers: [WorklistDataService, SafeHtmlPipe, TradingPartnerService]
})
export class WorklistComponent implements OnInit, AfterViewInit {

  // standard format and validation
  Format: typeof Format = Format;
  Validation: typeof Validation = Validation;

  ApprovalStatusType: typeof ApprovalStatusType = ApprovalStatusType;
  DocumentType: typeof DocumentType = DocumentType;
  FileExplorerDisplay: typeof FileExplorerDisplay = FileExplorerDisplay;
  PrimeNgConfig = PrimeNgConfig;
  RouteLink: typeof RouteLink = RouteLink;
  TxnType: typeof Transaction = Transaction;
  WorklistType: typeof WorklistType = WorklistType;

  @ViewChild('dt') dt: Table;

  maxDate = new Date();

  // dropdown menu declarations
  breadcrumb: MenuItem[] = [];
  globalFilterText: string;

  submittedOnRange: Date[];
  dueOnRange: Date[];

  menuItem: MenuItem[];
  worklistMenu: SelectItem[];
  categoryMenu: SelectItem[];
  statusMenu: SelectItem[];
  txnTypeMenu: SelectItem[];
  unfilteredTxnTypeMenu: SelectItem[];
  nextStatusMenu: SelectItem[];

  viewFileInNewTab: boolean = false;

  selectedWorklist = WorklistType.User;     // worklist/workgroup selected by user
  selectedWorkItem: WorkItem;               // selected work item by user
  selectedStatus: ApprovalStatusType;       // selected status by user before updating a work item

  worklist = [];                            // worklist/workgroup array of WorkItem
  sortField: string = "dueDateOn";          // initial worklist sorted by due date
  activeWorklist: any;                      // pointer to the active worklist or workgroup
  worklistCount = [];                       // worklist/workgroup array of badge counts

  tableColumns: TableColumn[] = [];          // table columns for worklist or workgroup
  // activeTableColumns: TableColumn[];        // pointer to the active table columns

  searchOption = new SearchOption();

  approvalStatusRequest: ApprovalRequest;   // input object to make a call to approval-status common component
  approvalStatusRequestInTab: ApprovalRequest;   // input object to make a call to approval-status common component

  responseMessage: string;                  // response from user when updating a work item
  notifications: Notification[];            // notifications for the selected workitem
  notificationTableColumns: TableColumn[];

  visible: boolean = true;                  // flag to visibility of the updated datatable
  showSearch: boolean = false;              // flag to show search parameters
  displayDialog: boolean = false;           // flag to show work item detail
  loadFileExplorer: boolean = false;        // load file explorer to get work item related attachments
  workItemDetailTabIndex: number = 0;       // index for work item detail popup tab

  onboardDocType: DocumentType;
  onboardTxnTypeDropdown: SelectItem[] = [];
  workItemUserId: number;                   // if NewHireRequest, need to get userId of jobRequisitionCandidate

  activeTab: string;

  myToDoTasks: ToDo[];

  taskDisplayDialog: boolean = false;
  pendingTasks: number;

  selectedToDoTask: ToDo;
  selectedComment: ToDoComment;
  lanesDropdown: SelectItem[];
  users: UserInfo[];
  toDoTasksEntityType: SelectItem[] = [];
  assignedBy: UserInfo;

  helpOverview: boolean = false;
  helpViewWorkList: boolean = false;
  helpWorkItem: boolean = false;

  @ViewChild('actionWorklistTemplate') actionWorklistTemplate: TemplateRef<any>;
  @ViewChild('actionTaskTemplate') actionTaskTemplate: TemplateRef<any>;
  @ViewChild('notificationMsgTemplate') notificationMsgTemplate: TemplateRef<any>;

  constructor(public user: UserService, private growl: GrowlService, private commonDataService: CommonDataService,
              private fileService: FileService, private transform: CommonTransformationService, private dataService: WorklistDataService, private tradingPartnerService: TradingPartnerService,
              private commonTransService: CommonTransformationService) {
  }


  ngOnInit() {

    if (this.user.browserType == Browser.Chrome) {
      this.viewFileInNewTab = true;
    }
    this.buildMenu();
    this.initTableColumns();
    this.activeTab = WorklistType.User;

    // initialize worklist for user and also for group
    this.worklist[WorklistType.User] = [];
    this.worklist[WorklistType.Group] = [];

    // initialize worklist count badges to be displayed
    this.worklistCount[WorklistType.User] = new WorklistCount();
    this.worklistCount[WorklistType.Group] = new WorklistCount();

    // build the pull down menus and get user's worklist
    this.getWorklist(WorklistType.User);
  }

  /**
   * @desc add custom filter for p-calendar
   */
  ngAfterViewInit(): void {
  }


  onChangeTxnStructure(txnStructure: TxnStructure) {
    this.commonDataService.getTxnNames(txnStructure.id).subscribe(res => {
      this.txnTypeMenu = res;
    });
  }

  /**
   * @desc collaps or expand the search menu
   * @returns this.showSearch - not this.showSearch
   */
  onClickSearch() {
    this.showSearch = !this.showSearch;
  }

  /**
   * @desc loop through searchOption and set it to null
   * @returns this.searchOption - set to null
   */
  onClickClearSearchOptionWorklist() {
    for (let prop in this.searchOption) {
      this.searchOption[prop] = null;
    }
    this.txnTypeMenu = this.unfilteredTxnTypeMenu;
  }

  onClickClearSearchOptionTask() {
    for (let prop in this.searchOption) {
      this.searchOption[prop] = null;
    }
    this.getMyTasks();
  }

  /**
   * @desc build search query and invoke it
   * @param selectedWorklist - selected worklist (either worklist for the user or the group)
   * @param searchOption - selected search option(s)
   */
  onClickSearchWorklist(selectedWorklist: WorklistType, searchOption: SearchOption) {
    let params = new HttpParams();

    params = params.set('type', selectedWorklist);

    if (searchOption.txnStructure && searchOption.txnStructure.id) {
      params = params.append('txnStructId', searchOption.txnStructure.id.toString());
    }
    if (searchOption.txnType && searchOption.txnType) {
      params = params.append('transaction', searchOption.txnType);
    }
    if (searchOption.refId) {
      params = params.append('refId', searchOption.refId.toString());
    }
    if (searchOption.submittedBy) {
      params = params.append('submittedByFirstName', searchOption.submittedBy);
    }
    if (searchOption.submittedFor) {
      params.append('submittedForFirstName', searchOption.submittedFor);
    }
    if (searchOption.submittedDate) {
      params = params.append('submittedOn', searchOption.submittedDate);
    }
    if (searchOption.dueDate) {
      params = params.append('dueDateOn', searchOption.dueDate);
    }
    if (searchOption.status) {
      params = params.append('currentStatus', searchOption.status.name);
    }

    this.dataService.searchWorklist(params).subscribe(res => {
      this.worklist[selectedWorklist] = plainToClass(WorkItem, res.list);
      this.activeWorklist = this.worklist[selectedWorklist];
    });
  }

  /**
   * @desc set activeWorkList depends on the user's input
   * @param worklistType - e.value contains selected User or Workgroup
   */
  handleWorklistToggle(worklistType: WorklistType) {
    if (worklistType == WorklistType.User || worklistType == WorklistType.Group) {
      this.getWorklist(worklistType);
    } else if (worklistType == WorklistType.MyTasks) {
      this.getMyTasks();
    }
  }


  onClickEditToDoTask(toDo: ToDo) {
    this.selectedToDoTask = classToClass(toDo);
    this.selectedComment = new ToDoComment();
    this.selectedToDoTask.taskTodoComments.sort((a: ToDoComment, b: ToDoComment) => {
      return +(a.displayCreatedOn) - +(b.displayCreatedOn);
    });
    this.tradingPartnerService.getLanes(this.selectedToDoTask.subtype).subscribe(res => {
      this.lanesDropdown = this.commonTransService.convertToDropDown("lane", res['list'], "id");
      this.taskDisplayDialog = true;
    });
  }

  onClickUpdateToDoTask() {
    if (this.selectedComment.comment != null && this.selectedComment.comment.length > 0) {
      this.selectedComment.id = null;
      this.selectedComment.userId = this.selectedToDoTask.assignedToId;
      this.selectedToDoTask.taskTodoComments.push(this.selectedComment);
    }

    this.tradingPartnerService.updateOneTask(this.selectedToDoTask, this.selectedToDoTask.id).subscribe(res => {
      let index = this.myToDoTasks.findIndex(todoTask => todoTask.id == this.selectedToDoTask.id);
      if (index > -1) {
        this.myToDoTasks[index] = plainToClass(ToDo, res as ToDo);
        this.myToDoTasks = [...this.myToDoTasks];
        this.taskDisplayDialog = false;
      }
    });
  }

  searchUser(userName: string) {
    this.commonDataService.searchUserByName(userName).subscribe(res => {
      this.users = plainToClass(UserInfo, res.list);
    });
  }

  onSelectUser(user: UserInfo) {
    this.searchOption.assignedById = user.id;
  }


  onClickSearchTodoTasks(searchOption: SearchOption) {
    /**
     * @desc this method builds the search payload and calls the method
     */
    let datePipe = new DatePipe('en-US');

    let urlString = `/todo/tasks/search?count=-1`;
    for (let property in searchOption) {
      const value = <string>searchOption[property];
      if (value) {
        if (property == 'title') {
          urlString = urlString.concat(`&title=${value}`);
        }
        if (property == 'assignedById') {
          urlString = urlString.concat(`&assignedBy.id=${value}`);
        }
        if (property == 'dueDate') {
          let valueDueDate = datePipe.transform(value, Format.DataserviceDate);
          urlString = urlString.concat(`&dueDate=${valueDueDate}`);
        }
        if (property == 'subtype') {
          urlString = urlString.concat(`&subtype=${value}`);
        }

      }
    }
    this.tradingPartnerService.getTasksSearch(urlString).subscribe(res => {
      this.myToDoTasks = plainToClass(ToDo, res.list);
    });
  }

  /**
   * @desc Reload the worklist from the backend
   */
  onClickReloadWorklist() {
    this.getWorklist(this.selectedWorklist);
  }

  /**
   * @desc Show the selected work item detail to the user
   * @param workItem - selected work item
   */
  onClickShowWorkItemDetail(workItem: WorkItem) {

    this.dataService.getWorklistItemNextStatusAsDropdown(workItem.id).subscribe(res => {
      this.nextStatusMenu = res;
      this.selectedWorkItem = workItem;

      // initialize dialog variables before displaying
      this.selectedStatus = null;
      this.responseMessage = null;

      this.workItemDetailTabIndex = 0; // force showing the first tab of the work item detail
      this.displayDialog = true;
    });
  }

  /**
   * @desc download the selected file and view it on a separate browser tab.  a broser tab showing the selected file.
   * @param transaction - transaction type
   * @param refId - transaction reference id (entity row id)
   * @param pdfTemplateId - pdf template id for the transaction
   * @returns the selected file viewed on a separate browser tab
   */
  onClickViewFile(transaction: Transaction, refId: number, pdfTemplateId: number) {

    this.fileService.getTxnInPDFThenShowOnNewTab(transaction, refId, pdfTemplateId);
  }

  /**
   * @desc download the selected file and save it user's local file system
   * @param transaction - transaction type
   * @param refId - transaction reference id (entity row id)
   * @param pdfTemplateId - pdf template id for the transaction
   * @returns the selected file saved in user's browser download directory
   */
  onClickDownloadFile(transaction: Transaction, refId: number, pdfTemplateId: number) {

    this.fileService.getTxnInPDFThenSave(transaction, refId, pdfTemplateId);
  }

  /**
   * @desc cancel/close the pop-up work item detail dialog
   */
  onClickCancelWorkItem() {
    this.loadFileExplorer = false;
    this.displayDialog = false;
  }

  /**
   * @desc display appropriate tab menu when user selects one from the dialog button
   * @param e - selected tab
   */
  handleTabChange(index: number) {
    this.workItemDetailTabIndex = index;
    switch (index) {
      case (TabIndex.ApprovalHistory):
        this.getApprovalHistory(this.selectedWorkItem);
        break;
      case (TabIndex.Attachment):
        if (this.selectedWorkItem && this.selectedWorkItem.transaction == Transaction.NewHireRequest) {
          // get userId of the jobreq candidate to be used for file explorer
          // ToDo this may be a security issue - need to implement access control - after user becomes employee, nobody other than HR should be able access the file
          this.dataService.getJobRequisitionCandidateInfo(this.selectedWorkItem.refId).subscribe(res => {
            let jrc = plainToClass(JobRequisitionCandidateInfo, res as JobRequisitionCandidateInfo);
            if (jrc && jrc.id) {
              this.workItemUserId = jrc.userId;
              this.loadFileExplorer = true;
            }
          });
        } else {
          this.loadFileExplorer = true;
        }
        break;
      case (TabIndex.Notification):
        this.getNotifications(this.selectedWorkItem);
        break;
    }
  }

  /**
   * @desc  show approval status of the selected workitem in a popup dialog
   * @param workItem - selected workItem
   */
  onClickApprovalStatus(workItem: WorkItem) {
    this.approvalStatusRequest = new ApprovalRequest(workItem.transaction, workItem.refId);
  }

  /**
   * @desc  show approval status of the selected work item within the tab window
   * @param workItem - selected workItem
   */
  getApprovalHistory(workItem: WorkItem) {
    this.approvalStatusRequestInTab = new ApprovalRequest(workItem.transaction, workItem.refId, false, true);
  }

  /**
   * @desc show a list of notifications when selected by th user.
   * @param notification - selected notification from the workItem dialog
   */
  onClickShowMessage(notification: Notification) {
    //TODO need to implement it
    console.log("onClickShowMessage: notification = ");
    console.log(notification);
  }

  /**
   * @desc get worklist notifications
   * @param workItem  - selected work item
   */
  getNotifications(workItem: WorkItem) {
    this.dataService.getWorklistNotifications(workItem.id).subscribe(res => {
      this.notifications = plainToClass(Notification, res.list);
    });
  }

  /**
   * @desc update the work item status
   * @param workItem  - selected work item
   *        selectedStatus - selected work item status
   *        responseMessage - selected work item response message
   */
  onClickUpdateWorkItem(workItem: WorkItem, selectedStatus, responseMessage: string) {

    this.displayDialog = false;

    if (workItem && selectedStatus) {
      this.dataService.updateWorklistItem(workItem.id, selectedStatus, responseMessage).subscribe(res => {
        this.growl.add(GrowlType.Success, 'Worklist item status updated.');
        this.getWorklist(this.selectedWorklist);
      });
    } else {
      this.growl.add(GrowlType.Error, 'Worklist item status cannot be updated.');
    }
    this.loadFileExplorer = false;
  }

  private buildMenu(): void {
    this.breadcrumb = [];
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push({label: 'Worklist', routerLink: '/main/worklist'});


    this.worklistMenu = [];
    this.worklistMenu.push({label: 'Work List', value: WorklistType.User});
    this.worklistMenu.push({label: 'Work Group', value: WorklistType.Group});
    this.worklistMenu.push({label: 'My ToDos', value: WorklistType.MyTasks});

    this.menuItem = [
      {label: 'Detail', icon: 'fa fa-external-link', command: () => this.onClickShowWorkItemDetail(this.selectedWorkItem)},
      {label: 'Approval Status', icon: 'fa fa-user', command: () => this.onClickApprovalStatus(this.selectedWorkItem)}
    ];


    forkJoin(
      this.commonDataService.getStatusTypes(),
      this.commonDataService.getTxnStructureTypes(),
      this.commonDataService.getEnumPairAsDropdown(EnumType.Entity),
      this.commonDataService.getTxnNames()).subscribe(resArry => {
      this.statusMenu = resArry[0];
      this.categoryMenu = resArry[1];
      this.toDoTasksEntityType = resArry[2];
      this.unfilteredTxnTypeMenu = resArry[3];
      this.txnTypeMenu = this.unfilteredTxnTypeMenu;
    });
  }

  private initTableColumns(worklistType?: WorklistType): void {

    switch (worklistType) {
      case WorklistType.User:
        this.tableColumns = [
          {field: 'txnTypeCategory', header: 'Category'},
          {field: 'transaction', header: 'Transaction Type', format: TableFormat.TitleCase},
          {field: 'txnNumber', header: 'Transaction #'},
          {field: 'submittedOn', header: 'Submitted Date', format: TableFormat.Date},
          {field: 'dueDateOn', header: 'Due Date', format: TableFormat.Date},
          {field: 'submittedBySummary', subfield: "fullName", header: 'Submitted By'},
          {field: 'action', header: 'Action', template: this.actionWorklistTemplate},
        ];
        break;
      case WorklistType.Group:
        this.tableColumns = [
          {field: 'workgroupAssigneeFullName', header: 'Assigned To'},
          {field: 'txnTypeCategory', header: 'Category'},
          {field: 'transaction', header: 'Transaction Type', format: TableFormat.TitleCase},
          {field: 'txnNumber', header: 'Transaction #'},
          {field: 'submittedOn', header: 'Submitted Date', format: TableFormat.Date},
          {field: 'submittedBySummary', subfield: "fullName", header: 'Submitted By'},
          {field: 'action', header: 'Action', template: this.actionWorklistTemplate},
        ];
        break;
      case WorklistType.MyTasks:
        this.tableColumns = [
          {field: 'title', header: 'Title'},
          {field: 'subtype', header: 'Task Type', format: TableFormat.TitleCase},
          {field: 'description', header: 'Description'},
          {field: 'assignedByName', header: 'Assigned By'},
          {field: 'duedate', header: 'Due Date', format: TableFormat.Date},
          {field: 'completed', header: 'Completed', format: TableFormat.BooleanAsReadOnlyCheckbox},
          {field: 'action', header: 'Action', template: this.actionTaskTemplate},
        ];
        break;
      default:
        this.onboardTxnTypeDropdown = [
          {label: "Offer Letter", value: DocumentType.Letter},
          {label: "Onboard Policy", value: DocumentType.OnboardPolicyAck},
          {label: "Onboard Documents", value: DocumentType.OnboardDocumentAck},
        ];

        this.notificationTableColumns = [
          {field: 'sentOn', header: 'Sent Date', format: TableFormat.Date},
          {field: 'subject', header: 'Subject'},
          {field: 'type', header: 'Type'},
          {field: 'sentBy', header: 'Sent By'},
          {field: 'sentTo', header: 'Sent To'},
          {field: 'htmlBody', header: 'Message', template: this.notificationMsgTemplate},
        ];
        break;
    }
  }

  /**
   * @desc get user's worklist or workgroup
   * @param worklistType - USER or WORKGROUP
   */
  private getWorklist(worklistType: WorklistType) {
    this.activeTab = worklistType == WorklistType.User ? WorklistType.User : WorklistType.Group;

    this.dataService.getWorklist(worklistType).subscribe(res => {
      this.worklist[worklistType] = plainToClass(WorkItem, res.list);
      this.activeWorklist = this.worklist[worklistType];
      this.sortField = worklistType == WorklistType.User ? "dueDateOn" : "submittedOn";              // set the sorting field for the table
      this.initTableColumns(worklistType);

      this.user.worklistSubmittedOrApproved = 0;
      this.worklist[worklistType].forEach((item: WorkItem) => {
        if (item.currentStatus === ApprovalStatusType.Submitted || item.currentStatus == ApprovalStatusType.Approved) {
          this.user.worklistSubmittedOrApproved++;
        }
      });
      this.dataService.getMyTasks().subscribe(res => {
        let myToDoTasks = plainToClass(ToDo, res.list);
        let pendingTasks = myToDoTasks.filter(toDoTask => !toDoTask.completed).length;
        this.user.worklistSubmittedOrApproved += pendingTasks;
      });
    });
  }

  private getMyTasks() {
    this.activeTab = WorklistType.MyTasks;
    this.dataService.getMyTasks().subscribe(res => {
      this.myToDoTasks = plainToClass(ToDo, res.list);
      this.initTableColumns(WorklistType.MyTasks);
      this.pendingTasks = this.myToDoTasks.filter(toDoTask => !toDoTask.completed).length;
    });
  }
}

enum TabIndex {
  Main = 0,
  ApprovalHistory = 1,
  Attachment = 2,
  Notification = 3
}
